import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";
import Blog from "../Sections/weblog/Blog";
import Breadcrumb from "../Sections/weblog/Breadcrumb";

function Weblog() {
    const { data: {weblog,id} } = useGetSettingQuery()

    return ( 
        <>
            {weblog.topbar && <Breadcrumb/>}
            {weblog.blog && <Blog name={weblog.blog.name} caption={weblog.blog.caption} site_id={id}/>}
        </>
    );
}

export default Weblog;